import request from "graphql-request";
import { getToken } from "./helpers";
import { categoryDetailPageQuery } from "./Graphql/Queries/categoryPageQuery";
import logger from "./logger";

export async function fetchCategoryData(variables, url) {
  try {
    const token = await getToken();
    const headers = { authorization: token };
    const res = await request(url, categoryDetailPageQuery, variables, headers);
    return res;
  } catch (err) {
    logger(`Error in fetching category data`, "error");
    logger(err, "error"); // Log the actual error separately
  }
}